export default "__VITE_ASSET__DNwPllRS__";